module.exports = __webpack_public_path__ + "static/media/tweetstorm.4dd8cfe9.svg";